<template>
    <div
        class="cutaway-header pa-0 pt-4"
        :class="{ 'white bordered': $vuetify.breakpoint.xs }"
    >
        <div
            class="cutaway-header-content d-flex align-center"
            :class="{
                'px-6': $vuetify.breakpoint.mdAndUp,
                'pl-4 pr-6': $vuetify.breakpoint.smAndDown,
                'opened-sidebar': isOpenedSidebar,
                'justify-space-between': isCounterDisplayed || displayFavorite,
                'justify-end': !isCounterDisplayed && !displayFavorite
            }"
        >
            <PlotCounter
                v-if="isCounterDisplayed"
                :plotCounter="showPlotCount ? plotCount : null"
                :floorText="floor"
            />
            <ShareFavorite
                v-else-if="displayFavorite && widget === 'plot-grid'"
                :widget="widget"
            />
            <div>
                <v-btn
                    v-if="!$vuetify.breakpoint.xs"
                    v-show="!isOpenedSidebar"
                    outlined
                    class="habiteo-btn promoter-customization text-capitalize"
                    :class="{
                        'xs': $vuetify.breakpoint.xs,
                        'mr-4': $vuetify.breakpoint.mdAndUp,
                    }"
                    :small="$vuetify.breakpoint.xs"
                    @click="toggleSidebar"
                >
                    <v-icon
                        class="icon icon-horizontal-slider"
                        :left="$vuetify.breakpoint.mdAndUp"
                    />
                    <span
                        v-if="$vuetify.breakpoint.mdAndUp"
                        class="habiteo-body-2 text-none"
                    >
                        {{ $t('cutawayHeader.filters')}}
                    </span>
                </v-btn>

                <ToggleViewButton
                    class="d-inline-block"
                    :class="$vuetify.breakpoint.xs ? 'ml-2' : null"
                    :widget="widget"
                    :isOpenedSidebar="isOpenedSidebar"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { mapGetters } from 'vuex';

    import PlotCounter from '@/components/cutawayHeader/components/PlotCounter';
    import ToggleViewButton from '@/components/cutawayHeader/components/ToggleViewButton';
    import TextButton from '@/components/cutawayHeader/components/TextButton';
    import ShareFavorite from '@/components/cutawayHeader/components/ShareFavorite';

    export default {
        name: 'CutawayHeader',
        components: {
            PlotCounter,
            ToggleViewButton,
            TextButton,
            ShareFavorite
        },
        props: {
            widget: {
                type: String,
                required: true
            },
            plotCount: {
                type: Number,
                required: true
            },
            isOpenedSidebar: {
                type: Boolean,
                required: true
            },
            floor: {
                type: String
            }
        },
        computed: {
            ...mapGetters('widget', [
                'displayFavorite',
                'showPlotCount'    
            ] ),
            isCounterDisplayed() {
                return !this.displayFavorite || (this.displayFavorite && this.widget === 'cutaway');
            }
        },
        methods: {
            toggleSidebar() {
                EventBus.$emit('toggleSidebar', true);
            }
        }
    }
</script>

<style lang="scss">
    @import '@/assets/scss/components/_cutaway-header.scss';
</style>


// WEBPACK FOOTER //
// src/components/cutawayHeader/CutawayHeader.vue